// removed by extract-text-webpack-plugin
module.exports = {"siteIntro":"siteIntro__233sg","fadeOutSiteIntro":"fadeOutSiteIntro__2Vw4i"};


//////////////////
// WEBPACK FOOTER
// ./components/site-intro/style.scss
// module id = YSZn
// module chunks = 8